import './index.scss'
import Swiper from 'swiper/swiper-bundle.min.js'
$("header .nav li").eq(1).addClass("active");
var swiper = new Swiper(".swiper-pic .swiper", {
    slidesPerView: 3,
    spaceBetween: 39,
    loop:true,
    speed:1000,
    autoplay: {
        delay: 2000,
        disableOnInteraction: false,
    },
    pagination: {
        el: ".swiper-pic .swiper-pagination",
        type: "progressbar",
    },
    breakpoints: {
        320: { //当屏幕宽度大于等于320
        slidesPerView: 1,
        spaceBetween: 0,
        },
        768: { //当屏幕宽度大于等于768 
            slidesPerView: 2,
            spaceBetween: 30,
        },
        1280: { //当屏幕宽度大于等于1280
            slidesPerView: 3,
            spaceBetween: 39,
        }
    },
});